import { reatomAsync, withDataAtom } from "@reatom/async";
import { atom, action, withAbort } from "@reatom/framework";
import { FilterUserDto, FilterUserDtoRoleEnum } from "definitions/poizon-sso";
import { API } from "src/api";
import { withDebounce, withIsLoadingAtom } from "src/common/pipes";
import { PAGINATION_DEFAULT_STATE } from "src/constants/pagination";

export const usersFilter = atom<FilterUserDto>(
  {
    page: PAGINATION_DEFAULT_STATE.page,
    limit: PAGINATION_DEFAULT_STATE.pageSize,
  },
  "usersFilter",
);

export const setUsersFilterRole = action(
  (ctx, role: FilterUserDtoRoleEnum | undefined) => {
    usersFilter(ctx, {
      ...ctx.get(usersFilter),
      role,
      page: PAGINATION_DEFAULT_STATE.page,
    });
  },
  "setUsersFilterRole",
);

export const setUsersFilterSearch = action(
  (ctx, search: string | undefined) => {
    usersFilter(ctx, {
      ...ctx.get(usersFilter),
      search,
      page: PAGINATION_DEFAULT_STATE.page,
    });
  },
  "setUsersFilterSearch",
);

export const setUsersFilterPage = action((ctx, page: number) => {
  usersFilter(ctx, { ...ctx.get(usersFilter), page });
}, "setUsersFilterPage");

export const setUsersFilterLimit = action((ctx, limit: number) => {
  usersFilter(ctx, {
    ...ctx.get(usersFilter),
    limit,
    page: PAGINATION_DEFAULT_STATE.page,
  });
}, "setUsersFilterLimit");

export const getUsersWithFilter = reatomAsync(
  async (ctx, data: FilterUserDto) => {
    return API.userApi
      .userControllerGetAllUsers(data, {
        signal: ctx.controller.signal,
      })
      .then((response) => response.data);
  },
  "getUsersWithFilterRequest",
).pipe(
  withDataAtom({ data: [], totalItems: 0 }),
  withAbort(),
  withIsLoadingAtom(),
);

export const getUsersWithFilterWithDebouncing = getUsersWithFilter.pipe(
  withDebounce(500),
);
